import { Match,Switch } from 'solid-js';
import { DateTime } from 'luxon';

export function TrimmedTime(P:{time:string})
{
	return (
		<Switch>
			<Match when={formatDateTime(P.time,'mm') == '00'}>
        		{formatDateTime(P.time,'ha')}
			</Match>
			<Match when={true}>
        		{formatDateTime(P.time,'h:mma')}
			</Match>
		</Switch>
	);
}

export function CleanTime(P:{time:string}) 
{
	return (
		<Switch>
			<Match when={formatDateTime(P.time,'mm') == '00'}>
        		{formatDateTime(P.time,'ha')}
			</Match>
			<Match when={true}>
        		{formatDateTime(P.time,'h:mma')}
			</Match>
		</Switch>
	);
}

export function weekday(day) 
{
	const dayMap = {
		mon:'Monday', 
		tue:'Tuesday', 
		wed:'Wednesday', 
		thu:'Thursday', 
		fri:'Friday', 
		sat:'Saturday', 
		sun:'Sunday'
	};

	return dayMap[day];
}

export function week(week) 
{
	const weekMap = {
		first:'1st', 
		second:'2nd', 
		third:'3rd', 
		fourth:'4th', 
		last:'Last'
	};

	return weekMap[week];
}

export function daysOfWeekly(days)
{
	/* Assumes days can't be repeated */
	if (days.length==5 && !days.includes('sat') && !days.includes('sun'))
		return 'Weekdays';

	let ret = '';
	let sep = '';

	for (const day of days) {
		ret += sep + weekday(day) + 's';
		sep = ', ';
	}

	return ret;
}

export function genreList(a)
{
	let sep = '',ret='';

	if (a.mainGenre) { ret += a.mainGenre; sep = ', '; }
	if (a.otherGenre1) { ret += `${sep}${a.otherGenre1}`; sep = ', '; }
	if (a.otherGenre2) { ret += `${sep}${a.otherGenre2}`; sep=', '; }
	if (a.extraGenre) ret += `${sep}${a.extraGenre}`;

	return ret;
}

export function formatDateTime(value:string|Date,format:string)
{
	//XXX backend events page sends us undefines initially for unknown reasons, causing problems. Hence the guards.
	if (!value)
		return '';

	try {
		const dt = value instanceof Date
			? DateTime.fromJSDate(value)
			: DateTime.fromISO(value);
		return dt.toFormat(format);
	}
	catch(err) {
		log.error(err);
		return '';
	}
}	

/*
	Combine the genres from multiple artists.
	Interleaving the genres from the artists - giving primacy to the earlier artists.
*/
export function combinedGenres(artists)
{
	const genreSet = {};
	const fields = ['mainGenre','otherGenre1','otherGenre2','extraGenre'];

	for (const field of fields) 
		for (const artist of artists) 
			if (artist[field])
				genreSet[artist[field].toLowerCase()] = true;

	let sep = '',ret='';
	for (const key of Object.keys(genreSet)) {
		ret += `${sep}${key}`; 
		sep=', ';
	}

	return ret;
}

